<search-filter-item-range [model]="model" (apply)="Save($event)" (close)="Close($event)" [modalMode]="true"></search-filter-item-range>
